// authentication
export const ERROR_CODE_OLD_PASSWORD = 1585833529;
export const ERROR_CODE_REQUEST_EXPIRED = 1569495621;

// create company user
export const ERROR_CODE_USER_EMAIL_ALREADY_ASSIGNED = 1574933623;
